<ejs-dialog
	#modal
	cssClass="modal-md"
	(close)="closeModal()"
	[attr.data-test-id]="'practicePayAddCreditCardModal'">
	<ng-template #header>
		<div class="dlg-template">Add Credit Card</div>
	</ng-template>
	<ng-template #content>
		@if (errors.length) {
			<div class="alert alert-danger">
				<ul>
					@for (error of errors; track error) {
						<li><strong>{{ error }}</strong></li>
					}
				</ul>
			</div>
		}
		@if (isLoading) {
			<div class="text-center padding-md">
				<i class="fa fa-spinner fa-spin fa-2x"></i>
				<p class="margin-top-sm">Loading secure card form...</p>
			</div>
		}
		@if (iframeUrl && !isLoading) {
			<div class="practice-pay-iframe-container">
				<iframe
					[src]="iframeUrl"
					(load)="onIframeLoad()"
					class="practice-pay-iframe"
					[attr.data-test-id]="'practicePayCardIframe'">
				</iframe>
			</div>
		}
	</ng-template>
	<ng-template #footerTemplate>
		<ng-container>
			<button ejs-button iconCss="fa fa-times" type="button" (click)="closeModal()"
					[attr.data-test-id]="'practicePayAddCreditCardCancelButton'">Cancel
			</button>
		</ng-container>
	</ng-template>
</ejs-dialog>
